// Module
var code = "<div class=\"article\">\n  <div ui-view></div>\n</div>\n";
// Exports
module.exports = code;